import React from 'react'
import classNames from 'classnames'
import { Icon, Stack } from '@crossfit/ui'

import style from './style.module.css'

type Props = {
  children: React.ReactNode
  className?: string
}

export function Menu({ children, className }: Props) {
  return (
    <div className={classNames(style.menu, className)}>
      <button className={style.menuButton}>
        <Icon name='dotted-menu' className={style.icon} />
      </button>
      <Stack className={style.options} spacing={2}>
        {children}
      </Stack>
    </div>
  )
}

type MenuButtonProps = React.ComponentPropsWithoutRef<'button'> & {
  variant?: 'default' | 'destructive'
}

export function MenuButton({ variant, ...props }: MenuButtonProps) {
  return (
    <button className={classNames(style.button, style[variant])} {...props} />
  )
}
